module.exports = __webpack_public_path__ + "static/phil-280199d87a7412e9f68a552c20dc4f62.png";